import React from "react"
import Layout from "../components/Layout"
import Banner from "../components/Banner"
import About from "../components/Home/About"
import Services from "../components/Home/Services"
import StyledHero from "../components/StyledHero"
import { graphql } from "gatsby"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import FeaturedGites from "../components/Home/FeaturedGites"
import SEO from "../components/SEO"

export default ({ data }) => (
  <Layout>
    <SEO title="Gîtes à Saint-Pierre-les-Étieux dans le Cher" />
    <StyledHero home="true" img={data.defaultBcg.childImageSharp.fluid}>
      <Banner
        title="Le Moulin de Gâteau"
        info="Un endroit calme et authentique"
      >
        <AniLink fade to="/gites" className="btn-white">
          les gîtes
        </AniLink>
      </Banner>
    </StyledHero>
    <About />
    <Services />
    <FeaturedGites />
  </Layout>
)

export const query = graphql`
  query {
    defaultBcg: file(relativePath: { eq: "defaultBcg.jpeg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 4160) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`
